import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { deckmaLogo } from 'assets/images';
import { ROUTES } from 'constants/routes';
import { CustomButton } from 'components/CustomButton';
import { useAppDispatch, useAppSelector } from 'hooks';
import { getUser, signOut } from 'store/thunks';

import './AdminHeader.scss';

export const AdminHeader = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getUser());
  }, []);

  return (
    <header className="admin-header">
      <Link to={ROUTES.admin_authorized_partners}>
        <img src={deckmaLogo} alt="deckma_logo" width="180px" height="45px" />
      </Link>
      <div className="admin-header__actions">
        {user?.email && <span className="admin-header__email">{user.email}</span>}
        <CustomButton
          text="Logout"
          width="100px"
          height="25px"
          onClick={() =>
            dispatch(signOut()).then(() =>
              navigate(ROUTES.login, { replace: true })
            )
          }
        />
      </div>
    </header>
  );
};